
























































































import Vue from "vue";
import Component from "vue-class-component";
import { EcertCheckBalanceViewModel } from "@/chipply/view-model/EcertCheckBalanceViewModel";
import { Prop, Watch } from "vue-property-decorator";
import { DealerLogoDisplay } from "chipply-common";

@Component({
    components: {},
})
export default class EcertBalancePage extends Vue {
    @Prop()
    public eventId: number | null = null;
    public DealerLogoDisplay = DealerLogoDisplay;

    public vm = new EcertCheckBalanceViewModel();
    public async created() {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("storeid")) {
            this.eventId = Number(urlParams.get("storeid"));
        }
    }

    @Watch("eventId")
    public async eventIdChanged() {
        this.vm.eventId = this.eventId;
        await this.vm.getBranding();
    }
}
